@if (queue.length > 0) {
  <div class="qc-widget shadow" [class.qc-collapsed]="collapsed">
    <div class="qc-header" (click)="toggle()">
      <span class="qc-pulse"><i class="ri-phone-line"></i></span>
      <span class="fw-semibold flex-grow-1">
        {{ "label-title.calls-on-hold" | translate }}
        <span class="badge bg-warning text-dark ms-1">{{ queue.length }}</span>
      </span>
      <i class="ri-arrow-{{ collapsed ? 'up' : 'down' }}-s-line"></i>
    </div>

    @if (!collapsed) {
      <ul class="qc-list list-unstyled mb-0">
        @for (call of queue; track call.callId) {
          <li class="qc-row" (click)="answer(call)">
            <div class="qc-row-main">
              <div class="qc-number fw-semibold">{{ displayNumber(call) }}</div>
              <div class="qc-meta small text-muted">
                <i class="ri-time-line me-1"></i>{{ waitingSec(call) }}s
              </div>
            </div>
            <button type="button" class="btn btn-sm btn-link text-muted p-0 qc-x"
                    (click)="dismiss(call, $event)"
                    [attr.aria-label]="'button-title.dismiss' | translate">
              <i class="ri-close-line"></i>
            </button>
          </li>
        }
      </ul>
    }
  </div>
}
